import { css } from "styled-components";
import { TOKENS, BUTTON_STATES } from "../consts";
import getTypeToken from "./getTypeToken";
import getButtonBoxShadow from "./getButtonBoxShadow";

var getFocus = function getFocus(_ref) {
  var bordered = _ref.bordered;
  return css([":focus{", ";background:", ";}:focus:not(:focus-visible){box-shadow:none;background:", ";}:-moz-focusring,:focus-visible{", ";background:", ";}"], getButtonBoxShadow(BUTTON_STATES.FOCUS), bordered && getTypeToken(TOKENS.backgroundButtonFocus), bordered ? getTypeToken(TOKENS.backgroundButtonBordered) : getTypeToken(TOKENS.backgroundButton), getButtonBoxShadow(BUTTON_STATES.FOCUS), bordered && getTypeToken(TOKENS.backgroundButtonFocus));
};

export default getFocus;